// @ts-nocheck

import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class LinkComponent extends Component<any, any> {
  render() {
    const { disabled } = this.props
    if (disabled) {
      return <div>{this.props.children}</div>
    }
    return <Link {...this.props}>{this.props.children}</Link>
  }
}

LinkComponent.propTypes = {
  disabled: PropTypes.bool
}

export default LinkComponent
